<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-50 p-0">

            <form @submit.prevent="updateApp()">
                <div class="modal-header p-3">
                    <h5 class="mb-0">Editar Aplicação</h5>
                    <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
                </div>

                <div class="modal-body p-3">

                    <div class="mb-3 d-flex gap-2" >

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Nome da aplicação *" 
                            type="text" 
                            placeHolder="Digite aqui o nome da aplicação *"
                            v-model="aplicacaoEdit.nome"
                            />
                        </div>

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Nome do responsável pela aplicação *" 
                            type="text" 
                            placeHolder="Digite aqui o nome do responsável pela aplicação *"
                            v-model="aplicacaoEdit.responsavel"
                            />
                        </div>

                    </div>
                    
                    <div class="mb-3 d-flex gap-2">
                        

                        <div v-if="authStore.usuario.root" class="flex-1">
                            <SelectField
                            label="Parceria *"
                            labelOption="nome"
                            :options="getParcerias()"
                            placeHolder="Escolha uma parceria *"
                            valueProp="id"
                            :canClear="false"
                            v-model="aplicacaoEdit.parceriaId"
                            />
                        </div>

                    </div>

                </div>

                <div class="modal-footer p-3">

                    <ButtonField @click="closeModal" size="small" text="Fechar" type="light"></ButtonField>

                    <ButtonField size="small" text="Salvar" type="success" :submit="true" :isLoading="isLoading" :loadingText="'Salvando aplicação'"></ButtonField>

                </div>
            </form>

        </div>
    </div>

</template>

<script>
    import { useAplicacoesStore } from '@/stores/aplicacoes.js'
    import { useParceriasStore } from '@/stores/parcerias.js';
    import { toast } from 'vue3-toastify'
    import { useAuthStore } from '@/stores/auth.js';

    export default{
        props:{
            isVisible : {
                type : Boolean,
                default: false
            },
            aplicacao: {
                type: Object
            }
        },
        emits:['close'],
        data(){
            return{
                aplicacoesStore: useAplicacoesStore(),
                aplicacaoEdit: {},
                parceriasStore: useParceriasStore(),
                authStore: useAuthStore(),
                isLoading: false
            }
        },
        methods:{
            closeModal(){
                this.$emit('close');
            },
            async updateApp(){
                
                const AplicacaoCopy = {
                    id: this.aplicacaoEdit.id,
                    nome: this.aplicacaoEdit.nome,
                    responsavel: this.aplicacaoEdit.responsavel,
                    parceriaId: this.aplicacaoEdit.parceriaId,
                } 

                if (!AplicacaoCopy.parceriaId) delete AplicacaoCopy.parceriaId;

                this.isLoading = true
                const result = await this.aplicacoesStore.update(AplicacaoCopy)
                
                this.isLoading = false

                if(result.status){
                    toast.success("Aplicação atualizada com sucesso")
                    this.closeModal()
                    this.aplicacoesStore.get()
                }else{
                    toast.error(result.message)
                }

            },
            getParcerias(){
                const parcerias = this.parceriasStore.parcerias.filter(p => p.id != '')
                parcerias.unshift({id:'',nome:'Nenhuma'})
                return parcerias
            }
        },
         watch:{
            'aplicacao' : {
                handler(aplicacaoNew){
                    this.aplicacaoEdit = { ...aplicacaoNew }
                    if(!this.aplicacaoEdit.parceriaId) this.aplicacaoEdit.parceriaId = ''
                },
                immediate: true
            }
        },
        mounted() {
            if(this.authStore.usuario.root)
            {
                this.parceriasStore.get()
            }
        }
    }
</script>